<h2 [id]="identifierService.labelId('patProfilePrint', 'dialogTitle')" mat-dialog-title style="background-color: #004f71; color: white">
  {{ labels['label.gb.merlin_net_patient_profile'] }}
  <!-- <button mat-button mat-dialog-close style="left: 950px" class="closeIcon">X</button> -->
</h2>
<mat-dialog-content class="mat-typography">
  <div id="print-section">
    <div id="printHeader">
      <div class="row middle-xs">
        <div class="col-xs-3">
          <div class="box">
            <!-- <figure class="brand-logo"></figure> -->
            <img src="./assets/images/logo1.png" class="pdf-logo brand-img" />
          </div>
        </div>
        <div class="col-xs-4 center-xs">
          <div class="box">
            <span [id]="identifierService.labelId('patProfilePrint', 'headerPatName')">{{ getPatientName() }}</span>
            <span [id]="identifierService.labelId('patProfilePrint', 'headerPatNum')"> {{patientData ?.patient?.patientNum ? '('+ patientData.patient.patientNum +')' : ''}} </span>
            <br /> {{ patientProfileData?.deviceProduct?.deviceFullDescription}} , {{ data?.patRes?.patientDevices?.[0]?.prevSerialNum }}
            <br />  {{ patientProfileData ?.customerSummaryDTO ?.customerName }}
          </div>
        </div>
        <div class="center-xs col-xs-3">
          <div class="box">
            <div class="textLogos">
              <!-- <h3 style="margin-bottom: 0" id="app_title">{{translate('label.gb.title.merlin.pcn')}} </h3>  -->
              <div [id]="identifierService.labelId('patProfilePrint', 'translateTitle')" [innerHTML]="getTranslateTitle()"></div>
              <div class="text-align">Patient Care Network</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
                <table style="
                        border: solid 1px #000;
                        font-size: 0.9em;
                        font-family: Arial;
                    " width="100%">
          <tbody>
            <tr>
              <td width="45%">
                                <table width="100%" style="
                                        table-layout: fixed;
                                        word-wrap: break-word;
                                    ">
                  <tbody>
                    <tr>
                                            <th [id]="identifierService.labelId('patProfilePrint', 'thClinicName')" style="
                                                    padding-left: 5px;
                                                    width: 40%;
                                                " valign="top" align="left">
                        {{ labels['label.rpt.clinic_name'] }}:
                      </th>
                      <td [id]="identifierService.labelId('patProfilePrint', 'tdClinicName')">
                        {{ patientProfileData ?.customerSummaryDTO ?.customerName }}
                      </td>
                    </tr>
                    <tr>
                                            <th [id]="identifierService.labelId('patProfilePrint', 'thAddress')" valign="top" style="
                                                    padding-left: 5px;
                                                    width: 40%;
                                                " align="left">
                        {{ labels['label.gb.address'] }}:
                      </th>
                      <td>
                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.streetAddress
                          ) {
                          <span [id]="identifierService.labelId('patProfilePrint', 'DTOaddress1')" class="wrap-text">
                            {{
                            patientProfileData
                            ?.customerSummaryDTO
                            ?.addressDTO
                            ?.streetAddress
                            }}
                            <br />
                          </span>
                        }
                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.streetAddress2
                          ) {
                          <span [id]="identifierService.labelId('patProfilePrint', 'DTOaddress2')">
                            {{
                            patientProfileData
                            ?.customerSummaryDTO
                            ?.addressDTO
                            ?.streetAddress2
                            }}
                            <br />
                          </span>
                        }
                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.streetAddress3
                          ) {
                          <span [id]="identifierService.labelId('patProfilePrint', 'DTOaddress3')">
                            {{
                            patientProfileData
                            ?.customerSummaryDTO
                            ?.addressDTO
                            ?.streetAddress3
                            }}
                            <br />
                          </span>
                        }
                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO?.city
                          || patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.stateProvince) {
                          <span>
                            @if (
                              patientProfileData
                              ?.customerSummaryDTO
                              ?.addressDTO?.city
                              ) {
                              <span [id]="identifierService.labelId('patProfilePrint', 'clinicCity')">{{
                                patientProfileData
                                ?.customerSummaryDTO
                                ?.addressDTO?.city
                                }},
                              </span>
                            }
                            @if (
                              patientProfileData
                              ?.customerSummaryDTO
                              ?.addressDTO
                              ?.stateProvince
                              ) {
                              <span [id]="identifierService.labelId('patProfilePrint', 'clinicStateProvince')">
                                {{
                                patientProfileData
                                ?.customerSummaryDTO
                                ?.addressDTO
                                ?.stateProvince
                                }}
                              </span>
                            }
                            <br />
                          </span>
                        }

                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.zipCode
                          ) {
                          <span [id]="identifierService.labelId('patProfilePrint', 'clinicZipCode')">
                            {{
                            patientProfileData
                            ?.customerSummaryDTO
                            ?.addressDTO
                            ?.zipCode
                            }}
                            <br />
                          </span>
                        }
                        @if (
                          patientProfileData
                          ?.customerSummaryDTO
                          ?.addressDTO
                          ?.countryCd
                          ) {
                          <span [id]="identifierService.labelId('patProfilePrint', 'clinicCountry')" class="caps">
                            {{
                            getCountry(patientProfileData?.customerSummaryDTO?.addressDTO?.countryCd)
                            }}
                            <br />
                          </span>
                        }

                      </td>
                    </tr>
                    <tr>
                                            <th [id]="identifierService.labelId('patProfilePrint', 'thHomePhone')" style="
                                                    padding-left: 5px;
                                                    width: 40%;
                                                " align="left">
                        {{ labels['label.gb.home_phone'] }}:
                      </th>
                      <td [id]="identifierService.labelId('patProfilePrint', 'tdHomePhone')">
                        {{ patientProfileData ?.customerSummaryDTO ?.addressDTO?.mainPhone ?.countryCode }} {{ patientProfileData ?.customerSummaryDTO ?.addressDTO?.mainPhone ?.areaCode }} {{ getPhoneInfo( patientProfileData ?.customerSummaryDTO ?.addressDTO?.mainPhone
                        ?.phoneNum) }}
                      </td>
                    </tr>
                    <!-- <tr style="padding-left: 5px">
                                            <th [id]="identifierService.labelId('patProfilePrint', 'thPatientName')" style="
                                                    padding-left: 5px;
                                                    width: 40%;
                                                " align="left">
                      {{ 'label.gb.fax'] }}:
                    </th>
                    <td [id]="identifierService.labelId('patProfilePrint', 'tdPatientNameVal')">
                      {{ patientProfileData ?.customerSummaryDTO ?.addressDTO?.fax ?.countryCode] }} {{ patientProfileData ?.customerSummaryDTO ?.addressDTO?.fax ?.areaCode] }} {{ patientProfileData ?.customerSummaryDTO ?.addressDTO?.fax ?.phoneNum |
                      translate }}
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </td>
                            <td valign="top" style="
                                    border-left: solid;
                                    border-left-width: 1px;
                                ">
              <table width="100%" style="height: 100%">
                <tbody>
                                        <tr style="
                                                border-bottom: solid;
                                                border-bottom-width: 1px;
                                                height: 30%;
                                            ">
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                                                            <th [id]="identifierService.labelId('patProfilePrint', 'thPatientName')" style="
                                                            padding-left: 5px;
                                                            white-space: nowrap;
                                                            width: 30%;
                                                        " align="left" valign="top"> {{ labels['label.filter.patient_name'] }}:
                            </th>
                            <td>



                              @if (
                                patientProfileData
                                ?.patientDTO
                                ?.lastName
                                ) {
                                <span [id]="identifierService.labelId('patProfilePrint', 'patLastName')" class="wrap-text">
                                  {{
                                  patientProfileData
                                  ?.patientDTO
                                  ?.lastName
                                  }}, </span
                                  >
                                }
                                <span [id]="identifierService.labelId('patProfilePrint', 'patFirstName')" class="wrap-text">{{
                                  patientProfileData
                                  ?.patientDTO
                                  ?.firstName
                                }}</span>

                              </td>
                            </tr>
                            <tr>
                                                            <th [id]="identifierService.labelId('patProfilePrint', 'thPatientRecord')" style="
                                                                    padding-left: 5px;
                                                                    width: 30%;
                                                                " align="left">
                                {{ labels['label.gb.pat_record_no'] }}:
                              </th>
                              <td [id]="identifierService.labelId('patProfilePrint', 'tdPatientNum')">
                                {{ patientData ?.patient ?.patientNum }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                                            <td style="
                                                    padding-left: 5px;
                                                    width: 40%;
                                                " align="left" valign="top">
                        <span [id]="identifierService.labelId('patProfilePrint', 'medicalTeam')" style="font-weight: bold">{{
                          labels['label.rpt.medical_team']
                          }}: </span
                          >
                          @for (
                            phys of data?.patRes?.medTeam?.assigned?.slice(
                            1
                            ); track
                            phys; let isLast = $last; let isFirst = $first) {
                            <span [id]="identifierService.labelId('patProfilePrint', 'physName')"
                              >{{ getPhys(phys?.id) }}
                              {{
                              isLast ? '' : ', '
                              }}</span
                              >
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card fontStyle">
          <h3 [id]="identifierService.labelId('patProfilePrint', 'patientDetailsHeader')" class="headerStyle">
            {{ labels['label.gb.patientdetailsbr'] }}:
          </h3>
          <div class="gradient"></div>
          @if (!isCountryFrance) {
            <div class="card-body">
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'patName')" class="col-sm-3 print-div-section">
                  {{ labels['label.filter.patient_name'] }}:
                </div>
                <div class="col-sm-3 print-div-section">
                  <span [id]="identifierService.labelId('patProfilePrint', 'patLastNameNF')" class="wrap-text">
                    {{
                    patientProfileData?.patientDTO?.lastName
                    }}</span
                    >
                    @if (patientProfileData?.patientDTO?.firstName) {
                      <span [id]="identifierService.labelId('patProfilePrint', 'patFirstNameNF')"
                        class="wrap-text">,
                        {{
                        patientProfileData?.patientDTO?.firstName
                        }}</span
                        >
                      }
                      <br />
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'clinicLoc')" class="col-sm-3 print-div-section">
                      {{ labels['label.gb.cliniclocation'] }}:
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'clinicLocValue')" class="col-sm-3 print-div-section">
                      {{ clinicLocation }}
                    </div>
                  </div>
                  <div class="row">
                    <div [id]="identifierService.labelId('patProfilePrint', 'dateOfBirth')" class="col-sm-3 print-div-section">
                      {{ labels['label.gb.birth_date'] }}:
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'dobValue')" class="col-sm-3 print-div-section">
                      {{ patientData?.patient?.dateOfBirthStr }}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'gender')" class="col-sm-3 print-div-section">
                      {{ labels['label.gb.gender'] }}:
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'genderValue')" class="col-sm-3 print-div-section">
                      {{ gender }}
                    </div>
                  </div>
                  <div class="row">
                    <div [id]="identifierService.labelId('patProfilePrint', 'merlinNetNum')" class="col-sm-3 print-div-section">
                      {{ labels['label.gb.merlin_net_number'] }} :
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'merlinNetNumValue')" class="col-sm-3 print-div-section">
                      {{
                      patientProfileData?.patientDTO?.merlinNetId
                      }}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'patSpeaks')" class="col-sm-3 print-div-section">
                      {{ labels['label.gb.patient_speaks'] }}:
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'patSpeaksValue')" class="col-sm-3 print-div-section">
                      {{ language }}
                    </div>
                  </div>
                </div>
              }
              @if (isCountryFrance) {
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-3 print-div-section">
                      <div [id]="identifierService.labelId('patProfilePrint', 'frInsNumber')" class="wrap-text" data-tx-key="label.gb.INSnumber_long">
                        {{ labels['label.gb.INSnumber_long'] }}
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchinsNumber'
                                )
                            "
                        >
                        {{ patRes?.patient?.insNumber }}
                      </div>
                      <div [id]="identifierService.labelId('patProfilePrint', 'frFirstName')" class="wrap-text" data-tx-key="label.gb.firstname_long">
                        {{ labels['label.gb.firstname_long'] }}
                      </div>
                      <div
                        class=" wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchFirstName'
                                )
                            "
                        >
                        {{ patRes?.patient?.firstName }}
                      </div>
                      <div [id]="identifierService.labelId('patProfilePrint', 'frGivenNames')" class="wrap-text" data-tx-key="label.gb.givennames_long">
                        {{ labels['label.gb.givennames_long'] }}
                      </div>
                      <div
                        class=" wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchGivenName'
                                )
                            "
                        [maxLength]="100"
                        >
                        {{ patRes?.patient?.givenNames }}
                      </div>
                      <div class="wrap-text" data-tx-key="label.gb.firstname_used_long" [id]="identifierService.labelId('patProfilePrint', 'firstnameUsedLong')" [innerHtml]="labels['label.gb.firstname_used_long']">
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchusedGivenName'
                                )
                            "
                        >
                        {{ patRes?.patient?.usedGivenName }}
                      </div>
                      <div [id]="identifierService.labelId('patProfilePrint', 'frLastName')" class="wrap-text" data-tx-key="label.gb.lastname_long">
                        {{ labels['label.gb.lastname_long'] }}
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchLastName'
                                )
                            "
                        >
                        {{ patRes?.patient?.lastName }}
                      </div>
                      <div class="wrap-text" data-tx-key="label.gb.lastname_used_long" [id]="identifierService.labelId('patProfilePrint', 'lastnameUsedLong')" [innerHtml]="labels['label.gb.lastname_used_long']">
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchUsedLastName'
                                )
                            "
                        >
                        {{ patRes?.patient?.usedLastName }}
                      </div>
                    </div>
                    <div class="col-sm-3 print-div-section">
                      <div [id]="identifierService.labelId('patProfilePrint', 'frOID')" class="wrap-text" data-tx-key="label.gb.OID">
                        {{ labels['label.gb.OID'] }}
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchOidNumber'
                                )
                            "
                        >
                        {{ patRes?.patient?.oidNumber }}
                      </div>
                      <div [id]="identifierService.labelId('patProfilePrint', 'frDateOfBirth')" class="wrap-text" data-tx-key="label.gb.date_of_birth_long">
                        {{ labels['label.gb.date_of_birth_long'] }}
                      </div>
                      <div
                        class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchDateOfBirthStr'
                                )
                            "
                        >
                        {{ patRes?.patient?.dateOfBirthStr }}
                      </div>
                      <!-- <div class="labelText" data-tx-key="label.gb.pat_record_no">
                      {{ 'label.gb.pat_record_no'] }}
                    </div>
                    <div
                      class="infoText"
                      style="margin-bottom: 10px"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchPatientNum'
                                )
                            "
                      >
                      {{ patRes?.patient?.patientNum }}
                    </div> -->
                    <div
                      class="wrap-text"
                      [id]="identifierService.labelId('patProfilePrint', 'merlinNetNumber')"
                      [innerHtml]="labels['label.gb.Merlin.net_number']"
                    data-tx-key="label.gb.Merlin.net_number"></div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchMerlinNetId'
                                )
                            "
                      >
                      {{ patRes?.patient?.merlinNetId }}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'frClinicLoc')" class="wrap-text" data-tx-key="label.gb.clinic_loc">
                      {{ labels['label.gb.clinic_loc'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchClinicLocation'
                                )
                            "
                      >
                      {{ clinicLocation}}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'frEnrollment')" class="wrap-text" data-tx-key="label.gb.merlin_net_enrollment">
                      {{ labels['label.gb.merlin_net_enrollment'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchEnrollmentDate'
                                )
                            "
                      >
                      {{ patRes?.patient?.enrollmentDate }}
                    </div>
                  </div>
                  <div class="col-sm-3 print-div-section">
                    <div [id]="identifierService.labelId('patProfilePrint', 'frGender')" class="wrap-text" data-tx-key="label.gb.gender_long">
                      {{ labels['label.gb.gender_long'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchGender'
                                )
                            "
                      >
                      {{ gender }}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'frBirthCode')" class="wrap-text" data-tx-key="label.gb.birth_code_long">
                      {{ labels['label.gb.birth_code_long'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchPlaceOfBirth'
                                )
                            "
                      >
                      {{ patRes?.patient?.placeOfBirth }}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'frPatPrefers')" class="wrap-text" data-tx-key="label.gb.pat_prefers">
                      {{ labels['label.gb.pat_prefers'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchLang'
                                )
                            "
                      >
                      {{ language}}
                    </div>
                    <div [id]="identifierService.labelId('patProfilePrint', 'frSSN')" class="wrap-text" data-tx-key="label.gb.SSN">
                      {{ labels['label.gb.SSN'] }}
                    </div>
                    <div
                      class="wrap-text info-details"
                            [id]="
                                identifierService.dropdownId(
                                    'patient-details',
                                    'viewFrenchfranceSsn'
                                )
                            "
                      >
                      {{ patRes?.patient?.franceSsn }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="card fontStyle">
            <h3 [id]="identifierService.labelId('patientProfilePrintDialog', 'patientAddressContact')" class="headerStyle">{{ labels['label.gb.patient_address_contact'] }}:</h3>
            <div class="gradient"></div>
            <div class="card-body">
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'address1')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.address1'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'address1Value')" class="col-sm-3 wrap-text print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address?.address
                  }}
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'city')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.city'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'cityValue')" class="col-sm-3 print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address?.city
                  }}
                </div>
              </div>
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'address2')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.address2'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'address2Value')" class="col-sm-3 wrap-text print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address?.address2
                  }}
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'stateProvince')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.state_province'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'stateValue')" class="col-sm-3 print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address
                  ?.countryCd == 140
                  ? patientProfileData?.patientState
                  : patientProfileData?.patientDTO?.address?.state
                  }}
                </div>
              </div>
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'address3')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.address3'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'address3Value')" class="col-sm-3 wrap-text print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address?.address3
                  }}
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'zipPostCode')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.zip_post_code'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'zipPostCodeValue')" class="col-sm-3 print-div-section">
                  {{
                  patientProfileData?.patientDTO?.address?.zipCode
                  }}
                </div>
              </div>
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'homePhone')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.phone'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'homePhoneValue')" class="col-sm-3 print-div-section">
                  {{
                  patientProfileData?.patientDTO?.phone?.countryCode
                  }}
                  {{
                  patientProfileData?.patientDTO?.phone?.areaCode
                  }}
                  {{
                  getPhoneInfo(patientProfileData?.patientDTO?.phone?.phoneNum)
                  }}
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'country')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.country'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'countryValue')" class="col-sm-3 caps print-div-section">
                  {{ getCountry(patientProfileData?.patientDTO.address.countryCd) }}
                </div>
              </div>
              <div class="row">
                <div [id]="identifierService.labelId('patProfilePrint', 'otherPhone')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.other_phone'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'otherPhoneValue')" class="col-sm-3 print-div-section">
                  {{ patientProfileData?.patientDTO?.patientCallSms }}
                </div>

                <div [id]="identifierService.labelId('patProfilePrint', 'email')" class="col-sm-3 print-div-section">
                  {{
                  labels['label.gb.email_addr']
                  }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'emailValue')" class="col-sm-3 print-div-section">
                  {{ patientProfileData?.patientDTO?.email }}
                </div>
              </div>
            </div>
          </div>
          <div class="card fontStyle">
            <h3 [id]="identifierService.labelId('patProfilePrint', 'deviceInfoHeader')" class="headerStyle">
              {{ labels['label.gb.patient_device_information'] }}:
            </h3>
            <div class="gradient"></div>
            <div class="card-body">
                @if(isLP){
                    @for (dataDevice of patientProfileData?.implantedPatientDeviceDetails; track $index){
                    <div class="row">
                        <div class="col-sm-3 print-div-section" [id]="identifierService.labelId('patProfilePrint', 'devNameLp_' + $index)" [innerHtml]="labels['label.gb.dev_name']">
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'serialNoLabelLp')" class="col-sm-3 print-div-section">
                            {{ dataDevice?.deviceName }}
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'serialNoValueLp')" class="col-sm-3 print-div-section">
                            {{ labels['label.gb.serial_no'] }}:
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'implantDateLabelLp')" class="col-sm-3 print-div-section">
                            {{ dataDevice?.serialNumber }}
                        </div>
                    </div>
                    <div class="row">
                        <div [id]="identifierService.labelId('patProfilePrint', 'implantDateValueLp')" class="col-sm-3 print-div-section">
                            {{ labels['label.gb.implant_date'] }}:
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'docImplantLabelLp')" class="col-sm-3 print-div-section">
                            {{ dataDevice?.implantDate }}
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'docImplantValueLp')" class="col-sm-3 print-div-section">
                            {{ labels['label.gb.doc_perform_implant'] }}:
                        </div>
                        <div [id]="identifierService.labelId('patProfilePrint', 'deviceDescValue')" class="col-sm-3 print-div-section"
                            [innerHTML]="dataDevice?.implantingPhysicianName">
                        </div>
                    </div>
                    }
                } @else {
                <div class="row">
                <div class="col-sm-3 print-div-section" [id]="identifierService.labelId('patProfilePrint', 'devName')" [innerHtml]="labels['label.gb.dev_name']">
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'serialNo')" class="col-sm-3 print-div-section">
                  {{ patientProfileData?.deviceProducts?.[0]?.deviceFullDescription }}
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'serialNoValue')" class="col-sm-3 print-div-section">
                  {{ labels['label.gb.serial_no'] }}:
                </div>
                <div [id]="identifierService.labelId('patProfilePrint', 'implantDate')" class="col-sm-3 print-div-section">
                  {{ data?.patRes?.patientDevices?.[0]?.prevSerialNum }}
                </div>
                </div>
              }
              @if (isICM) {
                <div class="row">
                  <div [id]="identifierService.labelId('patProfilePrint', 'implantDateValue')" class="col-sm-3 print-div-section">
                    {{ labels['label.gb.implant_date'] }}:
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'docImplant')" class="col-sm-3 print-div-section">
                    {{ implantDate }}
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'docImplantValue')" class="col-sm-3 print-div-section">
                    {{ labels['label.gb.doc_perform_implant'] }}:
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'leadChamber')" class="col-sm-3 print-div-section"
                    [innerHTML]="patientProfileData?.implantedPatientDeviceDetails?.[0].implantingPhysicianName">
                  </div>
                </div>
              }
              @if (istrueAaiDevice) {
                <div class="row">
                  <div [id]="identifierService.labelId('patProfilePrint', 'leadChamberValue')" class="col-sm-3 print-div-section">
                    {{ labels['label.gb.lead_chamber'] }}:
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'leadModel')" class="col-sm-3 print-div-section">
                    {{
                    patientProfileData?.deviceProduct?.deviceName
                    }}
                  </div>
                </div>
              }
              @if (!isICM && !isLP) {
                <div class="row">
                  <div [id]="identifierService.labelId('patProfilePrint', 'leadModelValue')" class="col-sm-3 print-div-section">
                    {{ labels['label.gb.lead_model'] }}:
                  </div>
                  <div class="col-sm-3 print-div-section">
                    @if (leadsData?.length > 0) {
                      <span [id]="identifierService.labelId('patProfilePrint', 'leadModelNum')">
                        {{ leadsData[0].modelNum }}
                      </span>
                    }
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'leadMfg')" class="col-sm-3 print-div-section">
                    {{ labels['label.gb.lead_manufacturer'] }}:
                  </div>
                  <div class="col-sm-3 print-div-section">
                    @if (leadsData?.length > 0) {
                      <span [id]="identifierService.labelId('patProfilePrint', 'leadMfgValue')">
                        {{ leadsData[0].manufacturer }}
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          @if (!isICM && !isLP) {
            <div class="card">
              <h3 [id]="identifierService.labelId('patProfilePrint', 'clinicalStatusHeader')" class="headerStyle">
                {{ labels['label.gb.patient_clinical_status'] }}:
              </h3>
              <div class="gradient"></div>
              <div class="card-body">
                <div class="row fontStyle">
                  <div class="col-sm-3 print-div-section">
                    <div [id]="identifierService.labelId('patProfilePrint', 'pmDependent')">
                      {{ labels['label.gb.pacemaker_dependent'] }}:
                    </div>
                  </div>
                  <div [id]="identifierService.labelId('patProfilePrint', 'pmDependentValue')" class="col-sm-3 print-div-section"> {{pmDependent}} </div>
                </div>
              </div>
            </div>
          }
        </div>

</mat-dialog-content>

<div>
  <div class="flex flex-row gap-20 justify-space-between">
    <div [id]="identifierService.labelId('patProfilePrint', 'footerMsg')" class="pt-pb">
      {{ labels['msg.pa059.text'] }}
    </div>
    <div class="flex flex-row justify-flex-end item-start" style="flex-wrap: nowrap;">
      <mat-dialog-actions style="flex-wrap: nowrap;">
        <button [id]="identifierService.buttonId('patProfilePrint', 'close')" mat-dialog-close mat-raised-button color="accent">
          {{ labels['label.gb.close'] }}
        </button>
        <button [id]="identifierService.buttonId('patProfilePrint', 'print')" cdkFocusInitial (click)="printPage()" mat-raised-button class="merlin-button" mat-raised-button color="primary">
          {{ labels['label.gb.print'] }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
